const errors = {
    FACTORY_NOT_FOUND: "Factory Not Found"
}

export default errors;
